import { Flat } from "@mgi-labs/preview";

const chateauDeFresnesFlat: Flat = new Flat({
  name: "ChateauDeFresnes",
  paper: {
    layer: { url: "BlackSatin.png", name: "paper" },
  },
  design: {
    recto: {
      color: {
        layer: {
          url: "color.png",
          url_SD: "color.png",
          name: "color",
          width: 1622,
          height: 2048,
        },
      },
      goldFoil: {
        layer: {
          url: "goldFoil.png",
          url_SD: "goldFoil.png",
          name: "Foil Gold",
        },
      },
      varnish: {
        layer: { url: "varnish.png", url_SD: "varnish.png", name: "Varnish" },
      },
    },
  },
});

export default chateauDeFresnesFlat;
